

const state =
{
    compares: [],
};

const actions = {
    
    addCompare({ commit }, { measurementId, point, createdAt, channel, time, fft }) {
        commit('addCompare', { measurementId, point, createdAt, channel, time, fft });
    },
    removeCompare({ commit }, { measurementId, channel, }) {
        commit('removeCompare', { measurementId, channel, });
    }

};
const mutations = {

    addCompare(state, { measurementId, point, createdAt, channel, time, fft }) {
        //find data with same channel and measurement Id
        let index = state.compares.findIndex(x => x.measurementId == measurementId && x.channel == channel);
        if (index == -1) {
            state.compares.push({ measurementId, point, createdAt, channel, time, fft });
        }

    },

    removeCompare(state, { measurementId, channel }) {
        let index = state.compares.findIndex(x => x.measurementId == measurementId && x.channel == channel);
        if (index != -1) {
            state.compares.splice(index, 1);
        }
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
